
export default function WebMaintenanceDetail() {
    return (
        <>
            <div className='detail-section basicWeb  cSection'>
                <div className='cContainer'>
                    <div className='detailWrapper'>
                        <h1 className="title"><span>Reliable Website Maintenance</span><small> & Support</small> </h1>
                        <p className='text-1'>Keep your website secure, updated, and performing at its best with our comprehensive maintenance packages. Our dedicated support team ensures your online presence remains bug-free and optimized for maximum conversions.</p>
                    </div>
                </div>
            </div>
        </>
    )
}